import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Container, Row, Col, Form } from 'react-bootstrap';
import { ArrowLeft } from 'react-bootstrap-icons';
import SimulatorMotor from './SimulatorMotor';
import Modal, { ModalBody, ModalFooter, ModalHeader } from 'components/bootstrap/Modal';
import { isMobile } from 'react-device-detect';

const SimulatorPopUp = ({
	data,
	setEditModalSimulator,
	simulatorData,
	currentFormValue,
	setCurrentFormValue,
	handelCancel,
	handelCreateLine,
	children,
}) => {
	const scrollViewRef = useRef(null);
	const [scrollHeight, setScrollHeight] = useState(0);

	// Get window height for web
	const getWindowHeight = () => {
		return window.innerHeight;
	};

	useEffect(() => {
		// Initialize scroll height on component mount
		setScrollHeight(getWindowHeight() - 150);

		// Handle window resize
		const handleResize = () => {
			setScrollHeight(getWindowHeight() - 150);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	// const scrollToBottom = () => {
	// 	if (scrollViewRef.current) {
	// 		const element = scrollViewRef.current;
	// 		element.scrollTop = element.scrollHeight;
	// 		setScrollHeight((prev) => prev + (getWindowHeight() - 150));
	// 	}
	// };

	// const handleScrollViewLayout = () => {
	// 	scrollToBottom();
	// };


	// useEffect(() => {
	// 	var messageBody = document.querySelector('#modelBody');
	// 	messageBody.scrollTop = messageBody.scrollHeight;
	// }, [currentFormValue]);
	return (
		<Modal
			isOpen={true}
			setIsOpen={() => {
				
			}}
			isScrollable
			size='xl'
			className=''
			centered
						fullscreen={!!isMobile}
			
			>
			<ModalHeader
				setIsOpen={() => {
					setEditModalSimulator(false);
					setCurrentFormValue({});
				}}></ModalHeader>

			<ModalBody id='modelBody'>
				{/* <div
					ref={scrollViewRef}
					// onLoad={handleScrollViewLayout}
					style={styles.scrollContainer}> 
				*/}
				<SimulatorMotor
					currentFormValue={currentFormValue}
					setCurrentFormValue={setCurrentFormValue}
					simulatorData={simulatorData}
					// scrollToBottom={scrollToBottom}
				/>

				{/* </div> */}
			</ModalBody>
			<ModalFooter>
				<Row className='mt-3'>
					<Col>{children}</Col>
				</Row>
			</ModalFooter>
		</Modal>
	);
};

SimulatorPopUp.propTypes = {
	setEditModalSimulator: PropTypes.func.isRequired,
	data: PropTypes.object.isRequired,
	simulatorData: PropTypes.object,
	currentFormValue: PropTypes.object,
	setCurrentFormValue: PropTypes.func,
	handelCancel: PropTypes.func,
	handelCreateLine: PropTypes.func,
	children: PropTypes.node,
};

export default SimulatorPopUp;
